module.exports = __webpack_public_path__ + "img/menu-orange.e057db8c.svg";